import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../ui-common/button/button.component';
import { DialogRef } from '@angular/cdk/dialog';
import { TranslatePipe } from '../data/pipes/translate.pipe';
import { MarkdownPipe } from '../data/pipes/markdown.pipe';
import { SharedService } from '../data/shared.service';

@Component({
  selector: 'app-feature-answers-anonymous',
  imports: [CommonModule, ButtonComponent, TranslatePipe, MarkdownPipe],
  templateUrl: './feature-answers-anonymous.component.html',
  styleUrl: './feature-answers-anonymous.component.scss',
})
export class FeatureAnswersAnonymousComponent implements OnInit {
  dialogRef = inject(DialogRef);
  companyName = '';

  constructor(private sharedService: SharedService) { }

  ngOnInit(): void {
    this.companyName = this.sharedService.getCompanyName();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
